'use strict';

exports.__esModule = true;
exports['default'] = componentDidMount;

var _property = require('../others/property');

var _property2 = _interopRequireDefault(_property);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function componentDidMount(value) {
  return (0, _property2['default'])('componentDidMount', value);
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/lifecycle/componentDidMount.js
// module id = 578
// module chunks = 1